import React from "react";
import { Typography, Paper, Box } from "@mui/material";

const PolicyPage = ({ height }) => {
  console.log("first", height);
  return (
    <>
      <Paper
        elevation={3}
        sx={{
          padding: height ? "2rem" : "3rem",
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          maxHeight: height ? height : "100vh",
          overflow: "auto",
        }}
      >
        <Box
          style={{
            border: "1px solid black",
            margin: "1.5rem",
            padding: "2rem",
            borderRadius: "8px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              textAlign: "center",
              marginBottom: "1rem",
              fontFamily: "Inter",
              color: " #0B4A65",
            }}
          >
            Privacy Policy
          </Typography>

          <Typography
            variant="body1"
            paragraph
            sx={{ display: "inline", fontSize: "15px" }}
          >
            <Box>
              {" "}
              <b>Effective Date: </b>[Insert Date]
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <b>Last Updated:</b> [Insert Date]
            </Box>
          </Typography>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
            }}
            gutterBottom
          >
            1. Introduction
          </Typography>

          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Nirantara Ecoventures Private Limited is a private limited
                company incorporated under the Companies Act, 2013 having its
                registered office at New No.16 Old No.18, Chengalvarayan Street,
                Shenoy Nagar, Chennai, Egmore Nungambakkam, Tamil Nadu, India,
                600030 (hereinafter referred to as the <b>“Company”</b>). The
                Company owns, operates and manages the website{" "}
                <a href="https://nirantara.ai/">https://nirantara.ai/ </a>
                (hereinafter referred to as <b>“Website” </b>) including an
                optimized version of the Website designed for access via mobile
                phones, smart devices and other compatible devices (hereinafter
                referred to as <b>“WebApp Version”</b>) under the brand name
                “Vajra” (the Website and the WebApp Version shall be
                collectively referred to as the <b>“Platform”</b>).
              </Typography>

              <Typography
                sx={{ fontFamily: "Inter", fontSize: "13px", my: "30px" }}
              >
                Welcome to <b>Vajra (powered by Nirantara)</b> (
                <b>"We," "Our,"</b> or <b>"Us"</b>).
              </Typography>

              <Typography
                sx={{ fontFamily: "Inter", fontSize: "13px", my: "30px" }}
              >
                The <b>Nirantara ESG Tech Platform</b> is designed to{" "}
                <b>accelerate sustainability efforts for businesses</b> by
                seamlessly integrating with existing ERP systems. Unlike
                traditional ESG tools, our Platform goes beyond basic data
                capture, offering{" "}
                <b>deeper insights and accurate tracking of ESG performance </b>
                (hereinafter collectively referred to as <b>“Services”</b>).
              </Typography>

              <Typography
                sx={{ fontFamily: "Inter", fontSize: "13px", my: "30px" }}
              >
                We are committed to protecting Your privacy while providing
                industry-leading ESG solutions. This Privacy Policy (hereinafter
                referred to as <b>“Policy”</b>) outlines how we collect, use,
                store, and protect Your personal data in compliance with:
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Europe & UK:</b> General Data Protection Regulation (GDPR),
                UK GDPR
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>USA:</b> California Consumer Privacy Act (CCPA) & other state
                privacy laws
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Canada:</b> Personal Information Protection and Electronic
                Documents Act (PIPEDA)
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iv)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b> Asia-Pacific:</b> Personal Data Protection Acts (PDPA) of
                Singapore, Malaysia, Philippines, Australia & New Zealand
                Privacy Act
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (v)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Middle East:</b> UAE DIFC Data Protection Law, Saudi Arabia
                NDMO, Qatar & Bahrain Data Protection Laws
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (vi)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>Russia, Ukraine, Georgia, Azerbaijan:</b> National data
                protection regulations
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ my: "30px" }}>
              Please read the Policy before You continue to browse through the
              Platform and/or use the Services. By accessing or using our
              Platform, You acknowledge and agree to the terms of this Policy
              which are legally binding.. If You do not agree with the terms of
              this Policy, You may opt to not register or use the Platform or
              avail any of our Services.
            </Typography>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
            }}
            gutterBottom
          >
            2. Definitions
          </Typography>

          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                In addition to other words and expressions that may be defined
                elsewhere in this Policy, unless the context otherwise requires,
                the following capitalized terms wherever used in this Policy
                shall have the meaning as prescribed hereunder:
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                2.1
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>“Customer”</b> means any User who avails/has availed the
                Services offered on the Platform by the Company subject to the
                terms and conditions stipulated in these terms, specific service
                related terms, any disclaimers and any additional conditions
                displayed by the Company in any part of the Platform.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                2.2
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                <b>“Users”, “You”</b> or <b>“Your”</b> means any natural or
                legal persons/entities (including the Customers) who have access
                to the Platform for availing the Services offered by the
                Company, in accordance with these terms. The term{" "}
                <b>“Users”, “You”</b> or <b>“Your”</b>
                shall mean and include any other persons/entity who access the
                Platform without such a User account.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              mt: 4,
            }}
            gutterBottom
          >
            3. Information We Collect
          </Typography>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "1rem",
            }}
            gutterBottom
          >
            3.1 Our Approach to Data Collection
          </Typography>

          <Box sx={{ marginLeft: "2.5rem" }}>
            <Box sx={{ alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                We follow a data minimization principle, meaning we collect only
                the data necessary to:
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Provide and improve our Platform and Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Comply with regulatory requirements for ESG reporting.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Enhance security, fraud prevention, and risk mitigation.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iv)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Analyze and draw trends from the aggregated statistics of the
                User activity.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (v)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Enable the provision of Services to the User, including but not
                limited to providing Information (as defined below) and updates
                about the Services availed by the User.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (vi)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Improve our features and provide seamless service based on the
                Information and feedback received from the User.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (vii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Track the transactions and process payments.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (viii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Conduct research to administer the Platform and Services.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ix)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Send You relevant notifications through e-mails and SMS which
                add to the effectiveness of the Service.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (x)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Respond to any queries/doubts raised by You.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (xi)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Protect You against imminent harm to the rights, or safety of
                the Platform / Company or its Users or as required or permitted
                by law.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (xii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Send periodic emails for sharing information and updates
                pertaining to Your order, occasional Company news, updates,
                related Service information, etc.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "1rem",
              mt: 4,
            }}
            gutterBottom
          >
            3.2 Our Approach to Data Collection
          </Typography>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "3rem",
            }}
            gutterBottom
          >
            A. Data You Provide Directly
          </Typography>

          <Box sx={{ marginLeft: "4rem" }}>
            <Box sx={{ alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                When you create an account, subscribe, or interact with our
                Platform, you provide (collectively “Information”):
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Personal Information – Name, address, email address, Country,
                phone number, company name and address.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Account Credentials – Username, password (stored securely with
                encryption), We may also ask You to share the OTP sent via SMS
                or a password or to verify a link sent on Your e-mail address.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Billing & Payment Data – Processed securely by third-party
                payment providers.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iv)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                ESG & Sustainability Data – Emission reports, energy
                consumption, and other sustainability metrics.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "3rem",
              mt: 4,
            }}
            gutterBottom
          >
            B. Data Collected Automatically
          </Typography>

          <Box sx={{ marginLeft: "4rem" }}>
            <Box sx={{ alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                We collect technical and usage data automatically when You use
                our Platform:
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Device Information – IP address, browser type, operating system,
                device type.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Usage Data – Log files, timestamps, session duration, page
                views.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Geolocation Data – Based on IP address (only collected where
                legally permitted).
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "3rem",
              mt: 4,
            }}
            gutterBottom
          >
            C. Data Collected Automatically
          </Typography>

          <Box sx={{ marginLeft: "4rem" }}>
            <Box sx={{ alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px", mb: 2 }}>
                We will share your Information with third parties only in the
                ways that are described in this Policy. The Company may provide
                and utilize the Information and data collected to certain third
                parties as the Company may deem fit, for undertaking data
                analysis via third party analytical tools. The third party
                analytical tools are utilized in order to analyse the data and
                Information to personalize, drive insights and thereby provide a
                better performance, improve the quality of features and provide
                seamless services to the User. The Company does not sell, trade
                or rent your Information to any third party unless, we have been
                expressly authorized by You either in writing or electronically
                to do so.
              </Typography>

              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                If You integrate our Services with external tools, we may
                receive data from
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Regulatory databases (to validate ESG compliance).
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Connected third-party services (e.g., data analytics platforms).
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 1 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                Publicly available business information sources.
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              mt: 4,
            }}
            gutterBottom
          >
            4. How We Use Your Data
          </Typography>

          <Box sx={{ marginLeft: "1rem" }}>
            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (i)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                While You are using our Services on the Platform, we record Your
                responses and activity data, including textual and voice
                interactions with customer support or other representatives of
                the Company. These recordings are used solely for quality
                assurance, support improvement, and for the purpose of
                compliance with applicable laws. Further, consent for such
                recordings will also be explicitly obtained from the User,
                wherever required.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (ii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                We may use the Information to contact You from time to time, to
                provide You with the Services, enable provision of Services to
                You and share important information. We may ask You for more
                Personal Information for identification purposes if required.
                The User shall be permitted to access the Platform (via devices
                such as desktop or laptop) provided that the log in/access
                credentials match with the User credentials. In the event the
                User uses a new device to access or log-in to the Platform, the
                User shall be required to grant access for the new device, as
                may be required.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                (iii)
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                We will, at all times, provide the option to You to not provide
                the Personal Information, which we seek from You. In such event,
                however, the Company fully reserves the right not to allow
                further usage of the Platform or provide any Services thereunder
                to You.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "baseline", mb: 2 }}>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                We use Your data to:
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "1rem",
              mt: 4,
            }}
            gutterBottom
          >
            A. Providing & Enhancing Our Services
          </Typography>

          <ul style={{ paddingLeft: "3rem" }}>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Enable Users to generate ESG reports, calculate GHG emissions, and
              ensure compliance.
            </li>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Personalize User experience by saving preferences.
            </li>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Respond to customer support requests and inquiries.
            </li>
          </ul>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "1rem",
              mt: 4,
            }}
            gutterBottom
          >
            B. Legal & Regulatory Compliance
          </Typography>

          <ul style={{ paddingLeft: "3rem" }}>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Ensure adherence to ESG frameworks (BRSR, GRI, EU Taxonomy).
            </li>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Fulfill contractual and regulatory obligations.
            </li>
            <li style={{ fontFamily: "Inter", fontSize: "13px" ,  marginBottom: "0.2rem",}}>
              Cooperate with legal authorities when required by law.
            </li>
          </ul>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "1rem",
              mt: 4,
            }}
            gutterBottom
          >
            C. Security & Fraud Prevention
          </Typography>

          <ul style={{ paddingLeft: "3rem" }}>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Detect, prevent, and investigate fraudulent activities or
              unauthorized access.
            </li>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Implement multi-layered security controls.
            </li>
          </ul>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              fontFamily: "Inter",
              color: " #0B4A65",
              paddingLeft: "1rem",
              mt: 4,
            }}
            gutterBottom
          >
            D. Marketing & Communications
          </Typography>

          <ul style={{ paddingLeft: "3rem" }}>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Send newsletters and updates (only with user consent).
            </li>
            <li style={{ fontFamily: "Inter", fontSize: "13px",  marginBottom: "0.2rem", }}>
              Analyze trends and user behavior (via anonymized analytics).
            </li>
          </ul>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              fontFamily: "Inter",
              paddingLeft: "1rem",
              mt: 2,
            }}
            gutterBottom
          >
            We do NOT use personal data for automated decision-making that
            significantly impacts users.
          </Typography>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              5. Regional Legal Compliance
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  fontFamily: "Inter",
                  color: " #0B4A65",
                  paddingLeft: "1rem",
                }}
                gutterBottom
              >
                A. Europe & UK (GDPR Compliance)
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                Under <b>GDPR (EU & UK)</b>, we process personal data on these
                legal bases:
              </Typography>

              <ul style={{ paddingLeft: "2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>Consent</span> – for
                  marketing and non-essential cookies.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>
                    Contractual Necessity
                  </span>{" "}
                  – to provide services.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>
                    Legal Obligations
                  </span>{" "}
                  – for regulatory compliance.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>
                    Legitimate Interests
                  </span>{" "}
                  – improving services, fraud prevention.
                </li>
              </ul>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                <b>Data Subject Rights (GDPR Users):</b>
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (i)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Right to Access, Rectification, and Erasure.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (ii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Right to Restrict Processing or Object to Processing.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (iii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Right to Data Portability.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (iv)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Right to Withdraw Consent at any time.
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "2rem",
                }}
              >
                To exercise your rights, please contact{" "}
                <a href="mailto:support.vajra@nirantara.solutions">support.vajra@nirantara.solutions.</a>
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  fontFamily: "Inter",
                  color: " #0B4A65",
                  paddingLeft: "1rem",
                  mt: 4,
                }}
                gutterBottom
              >
                B. USA (CCPA & State Laws Compliance)
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                For users in <b>California (CCPA) & other US states</b> with
                privacy laws:
              </Typography>

              <ul style={{ paddingLeft: "2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Right to Know
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    what data is collected & how it is used.
                  </span>
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Right to Delete
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    (subject to legal exceptions).
                  </span>
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Right to Opt-Out
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    of data sales (we do not sell data).
                  </span>
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  No Discrimination
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    for exercising privacy rights.
                  </span>
                </li>
              </ul>

              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "2rem",
                }}
              >
                California users can request data access or deletion at{" "}
                <a href="mailto:support.vajra@nirantara.solutions">support.vajra@nirantara.solutions.</a>
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  fontFamily: "Inter",
                  color: " #0B4A65",
                  paddingLeft: "1rem",
                  mt: 4,
                }}
                gutterBottom
              >
                C. Canada (PIPEDA Compliance)
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                For Canadian users, we adhere to{" "}
                <b>
                  PIPEDA (Personal Information Protection and Electronic
                  Documents Act):
                </b>
              </Typography>

              <ul style={{ paddingLeft: "2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Data Collection based on
                  <span style={{ fontWeight: "bold" }}> user consent.</span>
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Transparency in data handling.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Rights to
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    access, correct, and request deletion
                  </span>{" "}
                  of data.
                </li>
              </ul>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  fontFamily: "Inter",
                  color: " #0B4A65",
                  paddingLeft: "1rem",
                  mt: 4,
                }}
                gutterBottom
              >
                D. Asia-Pacific (Singapore, Malaysia, Australia, etc.)
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                We comply with:
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (i)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  <b>
                    Singapore & Malaysia (PDPA – Personal Data Protection Act)
                  </b>
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (ii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  <b>Australia & New Zealand (Privacy Act)</b>
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "2rem",
                }}
              >
                <b>User Rights:</b> Access, correction, withdrawal of consent,
                and opt-out of marketing.
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  fontFamily: "Inter",
                  color: " #0B4A65",
                  paddingLeft: "1rem",
                  mt: 4,
                }}
                gutterBottom
              >
                E. Middle East (UAE, Saudi Arabia, Qatar, Israel, etc.)
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                We comply with:
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (i)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  <b>UAE’s DIFC Data Protection Law</b>
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (ii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  <b>Saudi Arabia’s NDMO & Cybersecurity Regulations</b>
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (iii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  <b>Qatar & Bahrain’s Personal Data Protection Laws</b>
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "2rem",
                }}
              >
                Users can exercise rights under applicable local laws.
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  fontFamily: "Inter",
                  color: " #0B4A65",
                  paddingLeft: "1rem",
                  mt: 4,
                }}
                gutterBottom
              >
                F. Russia, Ukraine, Georgia, Azerbaijan
              </Typography>

              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "2rem",
                }}
                gutterBottom
              >
                We comply with:
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (i)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Russia’s Federal Law on Personal Data
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (ii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Ukraine’s Personal Data Protection Law
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (iii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Georgia’s Law on Personal Data Protection
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "2rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (iv)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  Azerbaijan’s Data Protection Regulations
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "2rem",
                }}
              >
                Users can request data removal or restriction in compliance with
                national laws.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              6. How We Share Your Data
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "1.2rem",
                }}
                gutterBottom
              >
                We do not sell personal data but may share it with:
              </Typography>

              <ul style={{ paddingLeft: "1.2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Service Providers – Hosting, analytics, payment processing
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Regulatory Bodies – Any legal, governmental or regulatory
                  authority if it is required to comply with any legal order or
                  process, issued or commenced, in accordance with the
                  applicable laws .
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Business Partners – For ESG compliance and sustainability
                  reporting.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Employees or contractors or affiliated organizations on a
                  need-to-know basis in order to undertake process on the behalf
                  of the Company or to facilitate smooth functioning of our
                  Services, such as providing network services, IT support, and
                  customer service.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Our representatives, employees including any independent
                  contractors engaged by the Company, on a need-to-know basis
                  who shall extend Services availed by You, and contact You for
                  the same.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Any parent company, investor, subsidiary or acquirer in the
                  event of corporate sale, merger, reorganization, sale of
                  assets, dissolution, or bankruptcy.
                </li>
              </ul>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "1rem",
                }}
                gutterBottom
              >
                We ensure data transfer safeguards, including:
              </Typography>

              <ul style={{ paddingLeft: "1.2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Standard Contractual Clauses (SCCs) for international
                  transfers.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Encryption & Secure Access policies.
                </li>
              </ul>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              7. International Data Transfers
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "1.2rem",
                }}
                gutterBottom
              >
                As a global platform, data may be processed in multiple
                jurisdictions. We implement adequate safeguards, including:
              </Typography>

              <ul style={{ paddingLeft: "1.2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  EU-US Data Privacy Framework for transatlantic data transfers.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Data Localization Requirements in specific countries (where
                  applicable).
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Third-Party Transfer Agreements for vendors or partners who
                  process data across borders must sign data protection
                  agreements ensuring compliance with applicable laws.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Data minimization before transfer only for the data strictly
                  necessary for the intended processing purpose, and wherever
                  possible, use pseudonymization or anonymization.
                </li>
              </ul>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              8. Data Security
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "1.2rem",
                }}
                gutterBottom
              >
                We implement:
              </Typography>

              <ul style={{ paddingLeft: "1.2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Encryption (data at rest & in transit).
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Access Controls (multi-factor authentication).
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Regular Security Audits & Compliance Checks.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Incident Response Plan (documented and tested plan to respond
                  to data security incidents swiftly and effectively).
                </li>
              </ul>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  paddingLeft: "1.2rem",
                }}
                gutterBottom
              >
                Despite security measures, no system is 100% secure. Report
                concerns to <a href="mailto:support.vajra@nirantara.solutions">support.vajra@nirantara.solutions.</a>
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              9. Data Retention Policy
            </Typography>

            <Box>
              <ul style={{ paddingLeft: "1.2rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  We retain data{" "}
                  <span style={{ fontWeight: "bold" }}>
                    only as long as necessary
                  </span>{" "}
                  for legal and business purposes.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Users can{" "}
                  <span style={{ fontWeight: "bold" }}>
                    request deletion
                  </span>{" "}
                  (subject to regulatory requirements).We will put in place
                  measures such that Your Personal Information, which is in Our
                  possession or under Our control, is destroyed and/or
                  anonymized within 5 (five) years of it being reasonable to
                  assume that the following conditions have been met:
                </li>
              </ul>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "1rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (i)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  the Purpose for which that Personal Information was collected
                  has been completed; and
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  mb: 1,
                  paddingLeft: "1rem",
                }}
              >
                <Typography
                  component="span"
                  sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
                >
                  (ii)
                </Typography>
                <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                  retention is no longer necessary for any other reason
                  including compliance with applicable law.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              10. Cookies & Tracking (remove cookies policy section)
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "1.6rem",
                }}
              >
                We also use cookies for data collection. A cookie stores small
                bit of information stored by Your browser and tracks Your
                preferences which can be utilized in order to provide customised
                Services. This data is used to improve the Services and
                offerings, such as providing more content in areas of interest
                to a majority of Users. Users can opt-out of tracking as per
                regional laws, as they deem fit.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              11. Data Breach Notification Protocol
            </Typography>

            <Box>
              <ul style={{ paddingLeft: "1.4rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>Detection</span> –
                  Continuous security monitoring for potential breaches.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>
                    Internal Investigation:
                  </span>{" "}
                  – Events of breach are escalated to a dedicated incident
                  response team for root-cause analysis.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>
                    User Notification
                  </span>{" "}
                  – If required by law, We notify affected Users within the
                  legal timeframe, detailing the nature of the breach, what data
                  was affected, and the steps taken to mitigate the impact
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  <span style={{ fontWeight: "bold" }}>
                    Regulatory Reporting:
                  </span>{" "}
                  – Notifications are sent to the Data Protection Board or other
                  relevant authorities as required under local laws.
                </li>
              </ul>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              12. User Access Requests & Support
            </Typography>

            <Box>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "13px",
                  paddingLeft: "1.6rem",
                }}
              >
                <b>Users can request access, correction, or deletion via:</b>{" "}
                <a href="mailto:support.vajra@nirantara.solutions">support.vajra@nirantara.solutions</a>
              </Typography>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Requests are processed{" "}
                  <span style={{ fontWeight: "bold" }}>
                    within legal time limits.
                  </span>
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  To protect User data, we may require verification of identity
                  before processing any requests pertaining to access,
                  correction, or deletion of User data.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>A designated Data
                  Protection Officer is available for escalation of unresolved
                  concerns, in compliance with data protection laws.
                </li>
              </ul>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              13. Children’s Privacy
            </Typography>

            <Box>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Our Platform{" "}
                  <span style={{ fontWeight: "bold" }}>
                    is not intended for users under 16 years of age.
                  </span>
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  We{" "}
                  <span style={{ fontWeight: "bold" }}>
                    do not knowingly collect
                  </span>{" "}
                  or process children’s data.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Features such as targeted advertising, behavioral tracking, or
                  personalized recommendations are disabled for Users identified
                  as a child.
                </li>
                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  We may use reasonable age-gating or verification procedures to
                  prevent children under the age of 16 years from accessing
                  certain parts of the Platform.
                </li>

                <li
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    listStyle: "none",
                    marginBottom: "0.2rem",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>✔</span>
                  Where Services may inadvertently attract Users under the age
                  of 16 years, We may implement verifiable parental consent
                  mechanisms in accordance with applicable laws.
                </li>
              </ul>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              14. Policy Updates
            </Typography>

            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "Inter",
                paddingLeft: "1.6rem",
              }}
              gutterBottom
            >
              We reserve the right to update this Policy periodically. Users
              will be notified of significant changes via email or Platform
              notifications. We will take your continued use of our Services as
              the deemed acceptance of the new policies.
            </Typography>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
              15. Your Rights
            </Typography>

            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "Inter",
                paddingLeft: "1.6rem",
              }}
              gutterBottom
            >
              As the data principal of Your Information, You have the following
              rights in relation to your Personal Information and sensitive
              personal data that is available with Us:
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                mb: 1,
                paddingLeft: "1.6rem",
              }}
            >
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                a.
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The right to access the Information We hold about You and to
                obtain details of Your personal and sensitive Personal
                Information as held by Us at any time;
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                mb: 1,
                paddingLeft: "1.6rem",
              }}
            >
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                b.
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The right to withdraw your consent to the continued processing
                of your Personal Information, at any point of time, subject only
                to any legitimate reason that We may have for continued
                processing of your Personal Information in certain
                circumstances; and
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                mb: 1,
                paddingLeft: "1.6rem",
              }}
            >
              <Typography
                component="span"
                sx={{ pr: 1, fontFamily: "Inter", fontSize: "13px" }}
              >
                c.
              </Typography>
              <Typography sx={{ fontFamily: "Inter", fontSize: "13px" }}>
                The right to correct, update and/ or amend the details of your
                Personal Information as available with Us from time to time.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                fontFamily: "Inter",
                color: " #0B4A65",
                mt: 4,
              }}
              gutterBottom
            >
             16.	Contact Information
            </Typography>

            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "Inter",
                paddingLeft: "1.6rem",
                marginBottom:"1rem"
              }}
              gutterBottom
            >
              For privacy-related inquiries:
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "Inter",
                paddingLeft: "1.6rem",
              }}
              gutterBottom
            >
              <b>Email:</b> <a href="mailto:support.vajra@nirantara.solutions">support.vajra@nirantara.solutions</a>
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "Inter",
                paddingLeft: "1.6rem",
              }}
              gutterBottom
            >
              <b>Address:</b> New No.16 Old No.18, Chengalvarayan Street, Shenoy Nagar, Chennai, Egmore Nungambakkam, Tamil Nadu, India, 600030
            </Typography>
          </Box>


        </Box>
      </Paper>
    </>
  );
};

export default PolicyPage;
